export default __webpack_public_path__ + "static/media/DJI_0895.MP4.00_00_39_24.Still004.b97b7aa4.jpg";